@import "animations";

$loader-border-radius: var(--ux-loader-bar-radius);
$loader-size: var(--ux-loader-bar-size);
$loader-animation-duration: var(--ux-loader-animation-duration, 2s);
$loader-spinner-size: 50px;
$loader-spinner-border: 6px;

:host {
  display: inline-block;
}

:host([variant="horizontal"]) {
  background: var(--ux-loader-track-color);
  border-radius: $loader-border-radius;
  height: $loader-size;
  overflow: hidden;
  position: relative;
  width: 100%;

  &::before {
    content: "";
    animation: ux-horizontal-loader-loading $loader-animation-duration infinite ease;
    background: var(--ux-loader-bar-color);
    border-radius: $loader-border-radius;
    height: $loader-size;
    left: 50%;
    position: absolute;
    transform: translateX(-150%);
    width: 50%;
  }
}

:host([variant="spinner"]) {
  border: $loader-spinner-border solid $color-blue-menu-bg;
  border-radius: 50%;
  height: $loader-spinner-size;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  vertical-align: middle;
  width: $loader-spinner-size;

  &::after {
    animation: ux-spin 1s linear infinite;
    border: $loader-spinner-border solid transparent;
    border-radius: 50%;
    border-top-color: var(--ux-spinner-track-color);
    content: "";
    inset: -$loader-spinner-border;
    position: absolute;
  }
}

@media (prefers-reduced-motion) {
  :host([variant="horizontal"])::before {
    animation-duration: 4s;
  }

  :host([variant="spinner"])::after {
    animation-duration: 3s;
  }
}
